/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import CountUp from "react-countup";
import PropTypes from "prop-types";
import React from "react";
import VisibilitySensor from "react-visibility-sensor";
import {WealthyEnv} from "helpers";
import styled from "styled-components";

const rupeeSymbol = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-rupee-symbol.svg`;
const managerImage = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-man-with-folded-hands.svg`;
const productsImage = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-briefcase.svg`;


const propTypes = {
  delay: PropTypes.number.isRequired,
  visibilitySensorHandler: PropTypes.func.isRequired
};

const WhyJoinWealthy = ({
  delay,
  visibilitySensorHandler
}) => {
  const animateCount = (count, suffix, prefix = "") => {
    return (
      <VisibilitySensor
        delayedCall
        onChange={visibilitySensorHandler}
      >
        <CountUp
          decimal=""
          decimals={0}
          delay={delay}
          duration={1}
          end={count}
          prefix={prefix}
          redraw={!!delay}
          start={0}
          suffix={suffix}
        >
          {({countUpRef}) => (
            <span ref={countUpRef} />
          )}
        </CountUp>
      </VisibilitySensor>
    );
  };

  const EachDescriptionComponent = ({count, countText, contentSubText, contentText, imageSource}) => {
    return (
      <EachDescription>
        <img alt="why-join-wealthy-image" className="each-image" loading="lazy" src={imageSource} />
        <p className="description-heading">
          {animateCount(count, `${countText}`)}
          <br />
          {contentSubText}
        </p>
        <p className="content">
          {contentText}
        </p>
      </EachDescription>
    );
  };

  return (
    <Wrapper id="why-join-wealthy">
      <Description>
        <EachDescriptionComponent
          contentSubText="Investments"
          contentText="Managed by Wealthy Partners"
          count={5000}
          countText=" Crore+"
          imageSource={rupeeSymbol}
        />

        <EachDescriptionComponent
          contentSubText="Wealth Partners"
          contentText="From 175+ towns & cities in India"
          count={9000}
          countText="+"
          imageSource={managerImage}
        />

        <EachDescription>
          <img alt="why-join-wealthy-image" className="each-image" loading="lazy" src={productsImage} />
          <p className="description-heading">
            Multiple <br /> Financial Products
            <br />
          </p>
          <p className="content">
          From over 60+ companies
          </p>
        </EachDescription>
      </Description>

    </Wrapper>
  );
};

const EachDescription = styled.div`
  width: 30%;
  text-align: center;

  .description-heading {
    margin-top: 3rem;
    font-size: 3.6rem;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #1c1c1c;
  }
  .content {
    margin-top: 1.2rem;
    font-size: 1.8rem;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 2;
    letter-spacing: normal;
    color: #7e7e7e;
  }
  @media (max-width: 768px) {
    width: 100%;
    .description-heading {
      text-align: center;
      line-height: 1.2;
      font-size: 2.4rem;
    }
    .content {
      text-align: center;
      font-size: 1.8rem;
      line-height: 1.2;
      margin-bottom: 2.2rem;
    }
  }
`;

const Description = styled.div`
  display: flex;
  justify-content: space-around;
  width: 80%;
  margin: 0 auto;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Wrapper = styled.div`
  padding: 10rem 0;
  background-color: #fff;
  position: relative;
  z-index: 1;
`;

WhyJoinWealthy.propTypes = propTypes;

export default WhyJoinWealthy;
